import React from 'react';

class UnitPricesTable extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let tableHeader = this.props.header
        let tableData = this.props.tableData
            .map((item) => {
                return {
                    // tableData: [item.fundDescription,formatDate(this.props, new Date(item.fundExitValueDate), 3),(item.fundEntryValue),(item.fundExitValue)],
                    tableData: [item.fundDescription, (item.fundEntryValue),(item.fundExitValue)],
                    //tableData: [item.fundDescription, item.fundExitValueDate, (item.fundEntryValue),(item.fundExitValue)],
                    //tableData: [item.fundDescription, (item.fundEntryValue),(item.fundExitValue)],
                }
            });
        let fundDate = "";
        if(this.props.tableData[0]){
            fundDate = this.props.tableData[0].fundExitValueDate;
        }

        return (
            <div className="">
                <h3 className="header3">Fund Date - {fundDate}</h3>
                <table class="table table-hover table-custom" tabIndex='0'>
                    <thead className='theads' onClick={this.sort} >
                        <tr style={{backgroundColor:"#f5f5f5"}} tabIndex='0'>
                            <th className="table-header-firstColumn-text" scope="col">{tableHeader}</th>
                            <th className="table-header-text" scope="col">Entry Price</th>
                            <th className="table-header-text" scope="col">Exit Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tableData.map((item)=>{
                                return(
                                    <tr tabIndex='0'>
                                    {
                                        item.tableData.map((item,index)=>{
                                            if(index === 0){
                                                return <th className="table-first-column-text" key={item + index} scope="row">{item}</th>
                                           // } else if(index === 1){
                                            //   return <td className="table-other-column-text date-column" key={item + index}>{item}</td>
                                            } else{
                                                return <td className="table-other-column-text" key={item + index}>{item}</td>
                                            }
                                        })
                                    }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default UnitPricesTable;
